/**
 * Canned replies of the composer's "quick messages" menu — ported verbatim from
 * cpanel `ChatMessageInput` (each entry is both the label and the inserted
 * text, in Uzbek / Russian pairs). They are message CONTENT, so they stay in
 * the language they are sent in; only the category headings are localized
 * (`inbox:quick.categories.<id>`).
 */
export interface QuickMessageCategory {
  /** i18n key suffix of the heading. */
  id: string;
  items: readonly string[];
}

export const QUICK_MESSAGE_CATEGORIES: readonly QuickMessageCategory[] = [
  {
    id: 'greeting',
    items: [
      'Assalomu alaykum, qanday yordam bera olaman?',
      'Здравствуйте, чем могу помочь?',
      'Hayrli kun. Savolingiz nimadan iborat?',
      'Добрый день. Подскажите, в чём ваш вопрос?',
      'Assalomu alaykum. Ma’lumotni aniqlayapman, biroz kutib turing.',
      'Здравствуйте. Уточню информацию, минутку.',
    ],
  },
  {
    id: 'clarify',
    items: [
      'Aniqlayapman, bir daqiqa.',
      'Уточняю, минутку.',
      'Bir lahza, tekshirib olayapman.',
      'Секунду, проверяю данные.',
      'Kutganingiz uchun rahmat, tafsilotlarni aniqlayapman.',
      'Благодарю за ожидание, уточняю детали.',
    ],
  },
  {
    id: 'result',
    items: [
      'Buyurtmangiz muvaffaqiyatli bekor qilindi. Sizga yana qanday yordam bera olaman?',
      'Ваш заказ успешно отменён. Чем ещё могу вам помочь?',
      'Buyurtma qayd etildi, kuryerni kutib turing.',
      'Заказ зафиксирован, ожидайте курьера.',
      'Yetkazib berish uchun to‘lov tez orada hisobingizga tushadi.',
      'Деньги за доставку будут начислены в ближайшее время.',
    ],
  },
  {
    id: 'finance',
    items: [
      'Bonus hisobingizga qo‘shildi, ilovani tekshiring.',
      'Бонус начислен на ваш баланс, проверьте приложение.',
      'To‘lov bugun kun oxirigacha tushadi.',
      'Выплата поступит сегодня до конца дня.',
    ],
  },
  {
    id: 'technical',
    items: [
      'Ilovani oxirgi versiyagacha yangilang.',
      'Попробуйте обновить приложение до последней версии.',
      'Ilovani qayta o‘rnating.',
      'Попробуйте переустановить приложение.',
      'Batareyani eng yaqin stansiyada almashtiring.',
      'Батарейку можно заменить на ближайшей станции.',
      'Agar skuter yoqilmasa, servis markaziga murojaat qiling.',
      'Если скутер не запускается, обратитесь в сервисный центр.',
    ],
  },
  {
    id: 'onboarding',
    items: [
      'Ulanish uchun Parkent 215 manzildagi ofisimizga keling.',
      'Для подключения приходите в офис по адресу Паркент 215.',
      'Amaldagi vakansiyalarni telegram kanalimizda ko‘rishingiz mumkin.',
      'Актуальные вакансии уточняйте в нашем телеграм-канале.',
    ],
  },
  {
    id: 'feedback',
    items: [
      'Taklifingiz uchun rahmat, uni mutaxassislarga yetkazamiz.',
      'Спасибо за предложение, мы передадим специалистам.',
      'Fikringiz biz uchun juda muhim.',
      'Ваш отзыв очень важен для нас..',
    ],
  },
  {
    id: 'couriers',
    items: [
      'Assalomu alaykum, hurmatli kuryer. Qanday yordam bera olaman?',
      'Здравствуйте, уважаемый курьер. Чем могу помочь?',
      'Agar bugun ishga chiqmadingiz, ilovani tekshirib ko‘ring. Buyurtma bekor qilinadi.',
      'Если вы сегодня не вышли на работу, проверьте приложение. Заказ будет отменён.',
      'Yangi slot talablari bo‘yicha buyurtmalarni faqat hamkorlardan bajarish kerak.',
      'По новым требованиям к слотам, заказы выполняются только у партнёров.',
      'Fikrlaringiz qayd etildi va mas’ullarga yetkaziladi.',
      'Ваши замечания зафиксированы и будут переданы.',
    ],
  },
  {
    id: 'closing',
    items: [
      'Sizga yana qanday yordam bera olaman?',
      'Чем ещё могу вам помочь?',
      'Qo‘shimcha savollaringiz bormi?',
      'Есть ли у вас дополнительные вопросы?',
      'Murojaatingiz uchun rahmat. Sizga yaxshi kun tilaymiz!',
      'Спасибо за обращение. Хорошего дня!',
    ],
  },
];
